<template>
	<div class="module-type-icon">
		<WidgetTypeIcon :serviceSlug="serviceSlug" :miniAppType="miniAppType" />
	</div>
</template>

<script>
import WidgetTypeIcon from '@/components/common/icons/WidgetTypeIcon';

export default {
	name: 'ModuleTypeIcon',
	components: { WidgetTypeIcon },
	computed: {},
	props: {
		serviceSlug: { type: String },
		miniAppType: { type: String },
		serviceVersion: { type: String },
	},
};
</script>

<style scoped lang="scss">
.module-type-icon {
	position: relative;
	height: 45px;
	width: 45px;
	border-radius: 10px;
	border: 1px solid var(--border-color);
	box-shadow: 0 3px 6px var(--border-color);
	background: var(--bg-color);
	overflow: hidden;
}
</style>
